// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"761":"SupportChat","818":"CookiePolicy"}[chunkId] + "-" + {"761":"c44772fbc3222e18f60d","818":"e970235c6dc4cc2cf058"}[chunkId] + ".js";
};